import {
    SW_UPDATE,
} from './SWConstants';
export const setUpdate = (hasUpdate) => ({ type: SW_UPDATE, hasUpdate });